<template>
	<div>
		<div class="actDiv" style="margin-top: -1rem;">
			<label style="font-size: 0.8rem;">给水号：</label>
			<a-input style="width: 10.5rem;margin-right: 0.625rem;" v-model="theApId"></a-input>
			<a-button size="small" icon="rocket" @click="doSearch">快速定位</a-button>
			<a-button style="margin-left: 1.25rem;" size="small" icon="form" @click="showUpdateOverFlow">修改最小流量阀值</a-button>
		</div>
		<baidu-map class="map" :center="center" :zoom="zoom" :scroll-wheel-zoom="true"
			:mapClick="false" @ready="handler">
				<bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-navigation>
				<div v-for="marker of dataList" :key="marker.id">
					<bm-marker :position="{lng: marker.longitude, lat: marker.latitude}" :title="marker.monitorName"
						 @dblclick="showInfo" :icon="marker.meterStatus=='1'?{url:require('@/assets/pin_green.png'),size:{width:36,height:36}}:{url:require('@/assets/pin_red.png'),size:{width:36,height:36}}">
					</bm-marker>
				</div>
				<bm-info-window :position="infoWindow.position"  :title="infoWindow.theMarker.monitorName"
					:show="infoWindow.show" @close="closeInfoWindow">
					<div style=" width: 20rem; padding: 0.5rem;">
						<a-row class="myRow">
							<a-col :span="8">
								<span>监控点地址：</span>
							</a-col>
							<a-col :span="16">
								<span>{{infoWindow.theMarker.monitorAddress}}</span>
							</a-col>
						</a-row>
						<a-row class="myRow">
							<a-col :span="8">
								<span>给水号：</span>
							</a-col>
							<a-col :span="16">
								<span>{{infoWindow.theMeter.apId}}</span>
							</a-col>
						</a-row>
						<a-row class="myRow">
							<a-col :span="8">
								<span>水表地址：</span>
							</a-col>
							<a-col :span="16">
								<span>{{infoWindow.theMeter.meterAddr}}</span>
							</a-col>
						</a-row>
						<a-row class="myRow">
							<a-col :span="8">
								<span>水表口径：</span>
							</a-col>
							<a-col :span="16">
								<span>{{infoWindow.theMarker.caliber}}</span>
							</a-col>
						</a-row>
						<a-row class="myRow">
							<a-col :span="8">
								<span>最新读数：</span>
							</a-col>
							<a-col :span="16">
								<span>{{infoWindow.theMeter.readData}}</span>
							</a-col>
						</a-row>
						<a-row class="myRow">
							<a-col :span="8">
								<span>上传时间：</span>
							</a-col>
							<a-col :span="16">
								<span>{{infoWindow.theMeter.readTime}}</span>
							</a-col>
						</a-row>
						<a-row class="myRow">
							<a-col :span="8">
								<span>水表状态：</span>
							</a-col>
							<a-col :span="16">
								<span>{{getMeterStatus(infoWindow.theMarker.meterStatus)}}</span>
							</a-col>
						</a-row>
						<a-row class="myRow">
							<a-col :span="8">
								<span>最小流量阀值：</span>
							</a-col>
							<a-col :span="16">
								<span>{{infoWindow.theMarker.overflow}} 立方米</span>
							</a-col>
						</a-row>
						<a-space :size="5" style="margin-top: 1rem;" align="center">
							<a-button :disabled="infoWindow.theMarker.meterStatus=='0'" size = "small" type="link" @click="showRealTimeStatis">实时报表</a-button>
							<a-button :disabled="infoWindow.theMarker.meterStatus=='0'" size = "small" type="link" @click="showDayFlowStatis">日报表</a-button>
							<a-button :disabled="infoWindow.theMarker.meterStatus=='0'" size = "small" type="link" @click="showMonthFlowStatis">月报表</a-button>
							<a-button :disabled="infoWindow.theMarker.meterStatus=='0'" size = "small" type="link" @click="showIntervalFlowStatis">间隔流量图形</a-button>
						</a-space>
					</div>
				</bm-info-window>
		</baidu-map>
		<MeterMonitorRealTimeStatis ref="realTimeStatis"/>
		<MeterMonitorFlowStatis ref="flowStatisView"/>
		<MeterMonitorIntervalStatis ref="intervalStatisView"/>
		<MeterMonitorOverFlowEditView ref="overFlowEditView" @doRefresh="getMeterMonitorList4Map"/>
		<MeterMonitorAnalysis ref="meterAnalysisView"/>
	</div>
</template>

<script>
	import {BmMarker} from 'vue-baidu-map'
	import MeterMonitorRealTimeStatis from '/src/components/MeterMonitorRealTimeStatis.vue'
	import MeterMonitorFlowStatis from '/src/components/MeterMonitorFlowStatis.vue'
	import MeterMonitorIntervalStatis from '/src/components/MeterMonitorIntervalStatis.vue'
	import MeterMonitorOverFlowEditView from '/src/components/MeterMonitorOverFlowEditView.vue'
	import MeterMonitorAnalysis from '/src/components/MeterMonitorAnalysis.vue'
	export default {
		components: {
			BmMarker ,
			MeterMonitorRealTimeStatis,
			MeterMonitorFlowStatis,
			MeterMonitorIntervalStatis,
			MeterMonitorOverFlowEditView,
			MeterMonitorAnalysis
		},
		data(){
			return {
				theApId:"",
				theMonitor:"",
				dataList:[],
				zoom:0,
				center:{lng:0 ,lat:0 },
				infoWindow:{
					show:false,
					position:{},
					theMarker:{},
					theMeter:{},
				},
			}
		},
		methods:{
			showUpdateOverFlow(){
				this.$refs.overFlowEditView.showView(this.dataList);
			},
			doSearch(){
				let a= this.getMarkerByApid(this.theApId);
				if(a!=null){
					this.infoWindow.theMarker = a;
					this.center.lng = a.longitude;
					this.center.lat = a.latitude;
					this.queryMeterInfo(a.meterId);
				}
			},
			getMarkerByApid(apid){
				let result = null;	
				for(var i=0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					if(item.meterApid == apid){
						result = item;
						break;
					}
				}
				return result;
			},
			closeInfoWindow:function(){
			},
			handler ({BMap, map}) {
				this.center.lng = 121.30955503;
				this.center.lat = 37.5365615629;
				this.zoom = 13;
			},
			getMeterMonitorList4Map(){
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_MAP_INFO_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			showInfo(e){
				let title = e.target.z.title;
				this.infoWindow.theMarker = this.getMarkerByTitle(title);
				this.queryMeterInfo(this.infoWindow.theMarker.meterId);
			},
			queryMeterInfo:function(meterId){
				this.infoWindow.show = false;
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_METER_INFO_URL);
				let param = {meterId:meterId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.infoWindow.theMeter = result;
						this.infoWindow.show = true;
						this.infoWindow.position = {lng: this.infoWindow.theMarker.longitude, lat: this.infoWindow.theMarker.latitude};
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			getMarkerByTitle(title){
				let result = null;
				for(var i=0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					if(item.monitorName == title){
						result = item;
						break;
					}
				}
				return result;
			},
			getMeterStatus:function(status){
				if(status == '1'){
					return "正常";
				}else{
					return "无链接";
				}
			},
			//实时报表
			showRealTimeStatis(){
				this.infoWindow.show = false;
				let meterId = this.infoWindow.theMarker.meterId;
				this.$refs.realTimeStatis.showView([meterId]);
			},
			//日流量报表
			showDayFlowStatis(){
				this.infoWindow.show = false;
				let meterId = this.infoWindow.theMarker.meterId;
				let startDate = this.$moment().subtract(1, "days").format('YYYY-MM-DD');
				let endDate = this.$moment().startOf("day").format("YYYY-MM-DD");
				this.$refs.flowStatisView.showView([meterId],1,startDate,endDate);
			},
			//月流量报表
			showMonthFlowStatis(){
				this.infoWindow.show = false;
				let meterId = this.infoWindow.theMarker.meterId;
				let startDate = this.$moment().format('YYYY-MM');
				let endDate = this.$moment().format("YYYY-MM");
				this.$refs.flowStatisView.showView([meterId],2,startDate,endDate);
			},
			showIntervalFlowStatis(){
				this.infoWindow.show = false;
				let meterId = this.infoWindow.theMarker.meterId;
				let startDate = this.$moment().subtract(1, "days").format('YYYY-MM-DD');
				let endDate = this.$moment().startOf("day").format("YYYY-MM-DD");
				this.$refs.intervalStatisView.showView([meterId],startDate,endDate);
			},
			showMeterAnalysis(){
				this.infoWindow.show = false;
				let meterId = this.infoWindow.theMarker.meterId;
				this.$refs.meterAnalysisView.showView([meterId]);
			},
		},
		created() {
			this.getMeterMonitorList4Map();
		}
	}
</script>

<style>
	.map {
		width: 100%;
		height: calc(100vh - 145px);
		margin-top: -0.5rem;
	}
	.myRow{
		margin-top: 0.625rem;
	}
</style>
